import { LabelDisplayedRowsArgs } from '@mui/material/TablePagination';
import { Slide, toast } from 'react-toastify';
import { TypeOptions } from 'react-toastify/dist/types';
import ToastCopyContent from '../../components/toast-message-copy-content';
import { SELECT_EMPTY } from '../consts';

export const sampleFunction = () => { };

export const getLocalStorageItem = (key: string) => {
    const item: any = window.localStorage.getItem(key);
    return item !== 'undefined' ? JSON.parse(item) : null;
};

export const setILocalStorageItem = (key: string, value: any) => {
    window.localStorage.setItem(key, JSON.stringify(value));
};

export const removeLocalStorageItem = (key: string) => {
    window.localStorage.removeItem(key);
};

export const getApiBaseUrl = () => {
    return process.env.REACT_APP_API_URL;
};

export function isObject(item: any) {
    return item && typeof item === 'object' && !Array.isArray(item);
}

export default function deepmerge(target: any, source: any, options: any = { clone: true }) {
    const output: any = options.clone ? { ...target } : target;

    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach(key => {
            if (key === '__proto__') {
                return;
            }

            if (isObject(source[key]) && key in target) {
                output[key] = deepmerge(target[key], source[key], options);
            } else {
                output[key] = source[key];
            }
        });
    }

    return output;
}

export const renderTablePaginationInfo = ({ from, to, count }: LabelDisplayedRowsArgs): string => {
    return `${count !== -1 ? count : `${to}'den fazla`} tanesinden ${from}-${to} `;
};

export const IsNullOrEmpty = (val: string | null | undefined): boolean => {
    return val === null || val === "" || val === undefined;

}

export const IsNullOrZero = (val: number | null | undefined): boolean => {
    return val === null || val === 0 || val === undefined;
}

export const IsValidTckn = (val: string | null | undefined): boolean => {
    return /^[1-9]{1}[0-9]{9}[02468]{1}$/.test(val ?? '');
}

export const IsOnlyLetters = (val: string) => {
    return /^[A-Za-zşŞıİçÇöÖüÜĞğ\s]+$/g.test(val);
}

export const IsValidEmail = (val: string) => {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val);
}

export const IsSelectEmpty = (val: any): boolean => {
    return val === null || val === SELECT_EMPTY;
}

export const ClearNonNumberChars = (val: string): string => {
    return val.replace(/\D/g, '');
}

export const handleToggleCheckIds = (id: number, array: number[]): number[] => {
    const currentIndex = array.indexOf(id);
    const newChecked = [...array];

    if (currentIndex === -1) {
        newChecked.push(id);
    } else {
        newChecked.splice(currentIndex, 1);
    }

    return newChecked;
}

interface ToastMessageProps {
    title: string,
    message?: string | JSX.Element,
    messageType: TypeOptions,
    timeout?: number,
}

export const toastMessage = (props: ToastMessageProps) => {
    toast((
        <div className='toast-message-text'>
            <h4>{props.title}</h4>
            {typeof props.message === 'string' ? <p>{props.message}</p> : props.message}
        </div>
    ), {
        type: props.messageType,
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: props.timeout ?? 5000,
        closeOnClick: false,
        draggable: false,
        pauseOnFocusLoss: false,
        theme: 'colored',
        transition: Slide,
    })
}

export const handleNoResultToList = (resourseName: string) => {
    toastMessage({
        messageType: toast.TYPE.WARNING,
        title: `Listelenecek ${resourseName} bulunamadı.`
    });
}

export const handleServerErrorMessage = (message?: string, title?: string) => {
    toastMessage({
        messageType: toast.TYPE.ERROR,
        title: title ?? 'Hata',
        message: message ? <ToastCopyContent text={message} /> : 'Beklenmedik bir hata oluştu'
    });
}

export const ParseDate = (val: string | null | undefined) => {
    if (val) {
        const [day, month, year] = val.split('.');
        return new Date(+year, +month - 1, +day);
    }
    return val === undefined ? null : val;
}

export const ParseDateTime = (val: string | null | undefined) => {
    if (val) {
        const [dateValues, timeValues] = val.split(' ');
        const [day, month, year] = dateValues.split('.');
        const [hours, minutes, seconds] = timeValues.split(':');
        return new Date(+year, +month - 1, +day, +hours, +minutes, +seconds);
    }
    return val === undefined ? null : val;
}